import React from 'react'

function AssetMark() {

    return (
        <div>
            <p>
                AssetMark provides independent advisors and their clients unique investment and wealth
                management solutions. Through their platform, they are able to provide investment solutions
                that may not be normally available to the average investor, by lowering the minimum amount
                required by the portfolio manager. Their platform includes the research material and
                mechanisms for portfolio designs, client account documentation and on-going account support.
            </p>
            <p>
                AssetMark’s investment solutions undergo a rigorous due diligence process that ensures the
                investment solutions fit into and complement the investment lineup, providing advisors with a
                range of solutions in each category and diverse approaches to investing. Their due diligence
                team also performs on-going extensive reviews of these solutions with comprehensive
                evaluations and visits to strategist’s offices.
            </p>
        </div>
    )
}
export default AssetMark